import App from "./App.vue";
import { createApp, ref } from "vue";
import { createRouter, createWebHistory } from "vue-router";



// import '@/assets/main.css'
import './assets/main.css'
import '../public/css/style.css';

import routes from "@/routes";
import store from "./store";
import * as API from "./API";
import bus from "@/utils/bus";
import { initNotificationRealtime } from "@/realtime/notificationsChannel";
import { isChunkLoadError } from "@/utils/isChunkLoadError";
import { reloadOnChunkFailure, clearChunkReloadFlag } from "@/utils/reloadOnChunkFailure";
import { initAdTypeConfig } from "@/config/adTypes";

// import 'flowbite';

// PrimeVue Configuration
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import 'primeicons/primeicons.css';

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.onError((error) => {
	if (isChunkLoadError(error)) {
		reloadOnChunkFailure();
		return;
	}
	console.error(error);
});

let previousPath = "";

router.beforeEach((to, from, next) => {
	console.log("from", from.fullPath, "to", to.fullPath);

	if (to.meta.title) {
		//wait for pageTitle to be set in localStorage
		const waitforPageTitle = () => {
			// Check if tenant data exists in localStorage
			const tenantData = JSON.parse(localStorage.getItem('tenantData') || '{}');
			if (tenantData && tenantData.pageTitle) {
				const pageTitle = tenantData.pageTitle;
				document.title = pageTitle ? `${to.meta.title} | ${pageTitle}` : to.meta.title;
			} else {
				// Keep checking until loader data is available
				setTimeout(waitforPageTitle, 100);
			}
		};
		waitforPageTitle();
	}

	const currentUserDetails = store.getters.getCurrentUser;
	const isLoggedIn = !!currentUserDetails?.id;
	console.log("isLoggedIn", isLoggedIn);

	const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
	const requiresRedirection = to.matched.some(record => record.meta.requiresRedirection);
	const previous = to.query.previous;

	// 1. Protected route and not logged in
	if (requiresAuth && !isLoggedIn) {
		console.log("Protected route: Not logged in");
		return next({
			name: "auth",
			query: { previous: to.fullPath },
		});
	}

	// 2. Auth route, but already logged in → redirect to dashboard
	if (requiresRedirection && isLoggedIn) {
		console.log("Auth route: Already logged in");
		return next({ name: "dashboard" });
	}

	// 3. If coming from login with ?previous → redirect there
	if (from.name === "auth" && previous) {
		console.log("Redirecting to previous path:", previous);
		return next(previous);
	}

	// 4. Everything else proceeds
	next();
});


window.outliner = ref([]);
window.canvasState = ref({
	objects: [],
});

const app = createApp(App);

if (process.env.NODE_ENV === 'development') {
	app.config.devtools = true;
	console.log("<-Development Mode Enabled->");
}

import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
app.component('VueDatePicker', VueDatePicker);


export const loadOruga = async () => {
	const Oruga = (await import("@oruga-ui/oruga-next")).default;

	await Promise.all([
		import("@oruga-ui/oruga-next/dist/oruga.css"),
		import("@oruga-ui/oruga-next/dist/oruga-full.css"),
		import("@oruga-ui/oruga-next/dist/oruga-full-vars.css"),
	]);

	app.use(Oruga, {
		pagination: {
			iconNext: "icon-ic-active-next",
			iconPrev: "icon-ic-active-previous",
		},
		table: {
			sortIcon: "icon-ic-sorting",
			sortIconSize: "",
			ariaNextLabel: "Next page",
			ariaPreviousLabel: "Previous page",
			ariaPageLabel: "Page",
			ariaCurrentLabel: "Current page",
			tdClass: "rowalign",
		},
	});
};

(async () => {
	app
		.use(store)
		.use(router);

	initNotificationRealtime(store);

	// Prime the ad-type tag-support map from the backend (App\Enums\AdType)
	initAdTypeConfig();

	app
		.use(PrimeVue, {
			theme: {
				preset: Aura,
				options: {
					prefix: 'p',
					darkModeSelector: 'system',
					cssLayer: false
				}
			}
		});

	// Load Oruga plugin + CSS before mounting so /auth page has styles
	await loadOruga();

	// inject permission checking function to all components
	app.config.globalProperties.hasOrgPermission = store.getters.hasOrgPermission;
	app.config.globalProperties.hasOwnPermission = store.getters.hasOwnPermission;
	app.config.globalProperties.setReadonly = (state) =>
		store.dispatch("setReadonly", state);

	app.mount("#app");
	clearChunkReloadFlag();
})();



// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('/worker.js')
//     .then(function(registration) {
//       console.log('Service Worker registered with scope:', registration.scope);
//     })
//     .catch(function(error) {
//       console.error('Service Worker registration failed:', error);
//     });
// }


// app.config.devtools = true;
window.__FRAME_HISTORY = new Object(null);
window.__CURRENT_FRAME_ID = null;
window.__EDITOR_HISTORY = [];
window.__EDITOR_HISTORY_LOCK = false;
window.blobMap = new Object(null);
window.activeElement = null;
window.__ADCTV__VERSION__ = "0.8.0";
window.API = API;
window.__BUILD__TIMESTAMP = "%%_TIMESTAMP_%%";

bus.on("unmount", () => {
	app.unmount();
});
